import React, { useEffect, useState } from "react";
import Page from "../../components/page/Page";
import PageHeader from "../../features/page-header/PageHeader";
import { Space } from "../../components/space/Space";
import { TableComponent } from "../../components/table/TableComponent";
import { useLocation, useParams } from "react-router-dom";
import { useTable } from "../../components/table/hooks";
import { tableMapping } from "../../components/table/definitions";
import Box from "@amzn/meridian/box";
import { useAppSelector } from "../../app/store/hooks";
import Column from "@amzn/meridian/column";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { usePageHeader } from "../../features/page-header/hooks";
import { useBreadcrumbs } from "../../features/breadcrumbs/hooks";
import { Error404 } from "../error-404/Error404";
import { formatToStartCase, getTableKey, removeRealOrPersonal } from "../../utils/formattingUtils";

export const AssignedToMe: React.FC = () => {
    const { pathname } = useLocation();
    const { currentTable } = useTable();
    const { documentType } = useParams();
    const { alias } = useAppSelector(state => state.auth.user);
    const [currentTab, setCurrentTab] = useState(
        documentType === "TAX_RETURN" ? "PERSONAL_PROPERTY" : "REAL_PROPERTY"
    );
    const title =
        removeRealOrPersonal(tableMapping[getTableKey(documentType, currentTab)]?.label) ?? "";

    const { updatePageHeader } = usePageHeader();
    const { updateBreadcrumbs } = useBreadcrumbs();

    useEffect(() => {
        updatePageHeader({
            title: formatToStartCase(`${title} ${pathname.split("/")[1]}`),
        });
        updateBreadcrumbs([
            { text: "Home", href: "/" },
            { text: formatToStartCase(`${title} ${pathname.split("/")[1]}`), href: "#" },
        ]);
    }, [currentTab]);

    return title.trim() ? (
        <Page
            type="form"
            title={title}
            description={undefined}
            hasBreadcrumbs={true}
            actions={null}
            currentTable={pathname.split("/")[1]}
        >
            <Space size={"xs"} />
            <PageHeader />
            <Space size={"s"} />
            <Column>
                <TabGroup value={currentTab} onChange={setCurrentTab}>
                    <Tab
                        disabled={documentType === "TAX_RETURN"}
                        key={"real_property_tab"}
                        value={"REAL_PROPERTY"}
                    >
                        Real property
                    </Tab>
                    <Tab key={"personal_property_tab"} value={"PERSONAL_PROPERTY"}>
                        Personal property
                    </Tab>
                </TabGroup>
            </Column>
            <Space size={"s"} />
            <Box type={"fill"} backgroundColor={"principal"} spacingInset={"400"}>
                <TableComponent
                    onSearch={false}
                    tableName={getTableKey(documentType, currentTab)}
                    tableQueryParams={{
                        status: tableMapping[currentTable]?.status,
                        assignedTo: alias,
                        ...(documentType && {
                            documentType: documentType,
                        }),
                        associatedPropertyType: currentTab,
                    }}
                    data={[]}
                />
            </Box>
        </Page>
    ) : (
        <Error404 />
    );
};
